import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from './plugins/vuetify';
import VueCookies from 'vue-cookies'
import * as VueGoogleMaps from 'gmap-vue'

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBdU45psiHExX_4kqyM8x6_pLJhyMoqIn4',
    libraries: "places"
  },
});

Vue.use(VueCookies, {

});

Vue.prototype.$eventHub = new Vue();

new Vue({
  render: h => h(App),
  vuetify,
  router
}).$mount("#app");
